export default __webpack_public_path__ + "static/media/img4.49a3fc2b.jpg";